module.exports = "<prg-select-device rowClass=\"{{rowClass}}\" iconClass=\"lightbulb\" [source]=\"_lights|async\" (selected)=\"selected.next($event)\"></prg-select-device>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/select-light/select-light.component.html
// module id = 1578
// module chunks = 2